export const AppName = process.env.NEXT_PUBLIC_APP_NAME || 'Humura';

export const AppDescription = 'GBV Monitoring and Reporting';

export const PhoneNumberStart = {
  ['250']: '250',
  ['25078']: '25078',
  ['25079']: '25079',
  ['25073']: '25073',
  ['25072']: '25072',
  ['72']: '72',
  ['73']: '73',
  ['78']: '78',
  ['79']: '79',
  ['072']: '072',
  ['073']: '073',
  ['078']: '078',
  ['079']: '079',
};

export enum ResponseStatus {
  Yes = 'Yes',
  No = 'No',
}

export enum Currency {
  RWF = 'RWF',
}

export enum ExecutionStatus {
  ACHIEVED = 'ACHIEVED',
  ON_TRACK = 'ON_TRACK',
  AT_RISK = 'AT_RISK',
  AHEAD = 'AHEAD',
  BEHIND = 'BEHIND',
  NOT_STARTED = 'NOT_STARTED',
}
